<template>
  <div class="check-in-report">
    <div style="margin-bottom: 10px">
      <el-select
        v-model="search.gender"
        style="width: 200px; margin-right: 20px"
        placeholder="請選擇性別"
        clearable
        size="small"
      >
        <el-option label="M" :value="'M'" />
        <el-option label="F" :value="'F'" />
      </el-select>
      <el-select
        v-model="search.admissionType"
        style="width: 200px; margin-right: 20px"
        placeholder="請選擇生源"
        clearable
        size="small"
        multiple
        collapse-tags
      >
        <el-option
          v-for="item in typeList"
          :key="item.CODE"
          :label="item.TEXT"
          :value="item.CODE"
        />
      </el-select>
      <el-date-picker
        v-model="search.date"
        type="daterange"
        :clearable="false"
        range-separator="-"
        :start-placeholder="$t('app.checkInStartTime')"
        :end-placeholder="$t('app.checkInEndTime')"
        size="small"
      >
      </el-date-picker>
      <el-button
        type="primary"
        @click="reset"
        size="small"
        style="margin-left: 1rem"
        >{{ $t("app.reset") }}</el-button
      >
      <el-button
        type="success"
        icon="el-icon-search"
        @click="getList"
        size="small"
        >查詢報表</el-button
      >
    </div>

    <el-select
      v-model="columnKey"
      style="width: 200px"
      multiple
      collapse-tags
      placeholder="自定義列"
      clearable
      size="small"
    >
      <el-option
        v-for="item in initColumn"
        :key="item.Code"
        :label="item.Display"
        :value="JSON.stringify(item)"
      >
      </el-option>
    </el-select>
    <BookTypeOption
      v-model="bookType"
      style="margin-left: 20px; margin-right: 10px"
    />
    <el-button
      style="margin-bottom: 20px"
      type="primary"
      icon="el-icon-document"
      @click="handleDownload"
      size="small"
    >
      Export
    </el-button>
    <div class="table-container">
      <el-table
        :key="tableKey"
        stripe
        :data="tableData"
        style="width: 100%; color: black"
        ref="multipleTable"
        height="560"
      >
        <template v-for="col in column">
          <el-table-column
            :key="col.Code"
            align="center"
            :label="col.Display"
            :prop="col.Code"
            :width="col.Width"
          >
            <template slot-scope="scope">
              <template
                v-if="
                  col.Code === 'FullName' ||
                    col.Code === 'ChineseName' ||
                    col.Code === 'GuardianNameEn' ||
                    col.Code === 'GuardianNameCn' ||
                    col.Code === 'Major' ||
                    col.Code === 'Remark1' ||
                    col.Code === 'Remark2' ||
                    col.Code === 'Remark3' ||
                    col.Code === 'Remark4' ||
                    col.Code === 'Address' ||
                    col.Code === 'AddressWeekend' ||
                    col.Code === 'AddressCorrespndence'
                "
              >
                <div style="word-break: break-word">
                  {{ scope.row[col.Code] }}
                </div>
              </template>
              <template v-else>
                {{ scope.row[col.Code] }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>

<script>
import BookTypeOption from "./components/BookTypeOption";
import {
  getAdmissionType,
  getColumns,
  getList
} from "@/api/report/checkInReport";
import { delEmpty, downloadFileByBlob, formatDate } from "@/utils/utils";
import { download } from "@/api/download";
export default {
  components: { BookTypeOption },
  data() {
    return {
      tableKey: true,
      filename: "",
      autoWidth: true,
      bookType: "",
      typeList: [],
      columnKey: [],
      initColumn: [],
      search: {
        gender: "",
        admissionType: [],
        date: []
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
      floorList: [],
      title: "",
      exportUrl: "/HostelCheckInReport/Export"
    };
  },
  created() {
    this.init();
  },
  computed: {
    column() {
      if (this.columnKey.length < 1) {
        return this.initColumn;
      }
      return this.columnKey.map((i) => JSON.parse(i));
    }
  },
  watch: {
    columnKey: {
      handler() {
        this.tableKey = !this.tableKey;
      },
      deep: true,
    }
  },
  methods: {
    init() {
      this.getTypeList();
      this.getColumnGroup();
      this.getList();
    },
    getTypeList() {
      getAdmissionType().then((res) => {
        this.typeList = res.data;
      });
    },
    getColumnGroup() {
      getColumns().then((res) => {
        this.initColumn = res.data;
      });
    },
    getList() {
      getList(
        delEmpty({
          Gender: this.search.gender,
          AdmissionType:
            this.search.admissionType.length > 0
              ? this.search.admissionType.join(",")
              : [],
          CheckInStartTime: this.search.date[0] || "",
          CheckInEndTime: this.search.date[1] || "",
          PageIndex: this.currentPage,
          PageSize: this.size
        })
      ).then((res) => {
        this.total = res.data.Total;
        this.tableData = res.data.Items;
      });
    },
    reset() {
      this.search.admissionType = [];
      this.search.gender = "";
      this.search.date = [];
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleDownload() {
      download(this.exportUrl, {
        ExportMethod: this.bookType,
        HeaderValue: this.columnKey.map((_) => JSON.parse(_).Code).join(","),
        Gender: this.search.gender,
        AdmissionType:
          this.search.admissionType.length > 0
            ? this.search.admissionType.join(",")
            : [],
        CheckInStartTime: this.search.date[0] || "",
        CheckInEndTime: this.search.date[1] || "",
      }).then((content) => {
        let downloadFileExtension = this.selectExtension(this.bookType);
        var blobContent = new Blob([content]);
        downloadFileByBlob(
          blobContent,
          "Rooming-List-at-EAH-hostel-as-at-" +
            formatDate(new Date(), "yyyy-MM-dd") +
            downloadFileExtension
        );
      });
    },
    selectExtension(bookType) {
      if (bookType === "xlsx") {
        return ".xls";
      } else if (bookType === "word") {
        return ".doc";
      } else if (bookType === "pdf") {
        return ".pdf";
      } else {
        return ".xls";
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    createCellPos(n) {
      var ordA = "A".charCodeAt(0);
      var ordZ = "Z".charCodeAt(0);
      var len = ordZ - ordA + 1;
      var s = "";
      while (n >= 0) {
        s = String.fromCharCode((n % len) + ordA) + s;
        n = Math.floor(n / len) - 1;
      }
      return s;
    }
  }
};
</script>
<style lang="scss" scoped>
.check-in-report {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 80px);
  .table-container {
    height: calc(100% - 170px);
    overflow: auto;
  }
}
</style>
